import React from "react";

//images
import feature from "../images/history/history-featured-image.jpg";

const History = () => {
  return (
    <div className="row justify-content-center">
      <div className="col-11 col-xl-10 no-side-padding panel-history">
        <div className="row justify-content-center history-story">
          <div className="col-md-9 col-lg-6">
            <h3 className="text-uppercase text-blue">
              Los Angeles Professional Paving stone Installer
            </h3>
            <p className="mt-5">
              We have been installing paving stone driveways, patios and pool
              decks since 1999. We have earned a spot on the Inc. 500 list of
              fastest growing companies in America two times. We have a
              reputation for excellence and unparalleled quality of service
              around Southern California. All of our competent crews undergo
              thorough training and certification to ensure the value of their
              work meets the highest standards of our customers, every time. The
              owners of the company are not only ICPI (Interlocking Concrete
              Paver Institute) certified, but are also instructors, teaching
              other contractors how to properly install paving stones.
            </p>
          </div>
          <div className="col-md-9 col-lg-6 mt-4 mt-md-0 text-right">
            <img src={feature} alt="Feature" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default History;
